import DayPartingCards from "./DayPartingCards";
import { DAY_PARTING_DAYS } from "@ts/constants";

const DayPartingBody = ({ canManageDayParting }: { canManageDayParting: boolean }) => {
    return (
        <div
            className={`d-flex justify-content-between ${!canManageDayParting ? "pe-none opacity-50" : ""}`}
            tabIndex={-1}
            aria-disabled="true"
            style={{
                position: "absolute",
                top: "7rem",
                bottom: "5rem",
                left: "0.5rem",
                right: "0.5rem",
            }}
        >
            {DAY_PARTING_DAYS.map((day) => {
                return <DayPartingCards day={day} canManageDayParting={canManageDayParting} />;
            })}
        </div>
    );
};

export default DayPartingBody;
